import React from 'react';
import PropTypes from 'prop-types';
import ButtonGroup from '@material-ui/core/ButtonGroup';

type NkButtonGroupProps = {
  name?: string;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  orientation?: 'horizontal' | 'vertical';
  label?: string;
  isDisabled?: boolean;
  isRequesting?: boolean;
  children: React.ReactNodeArray | React.ReactNode;
};

const NkButtonGroup = (props: NkButtonGroupProps) => {
  return (
    <ButtonGroup
      variant={props.variant}
      color={props.color}
      size={props.size || 'medium'}
    >
      {props.children}
    </ButtonGroup>
  );
};

NkButtonGroup.propTypes = {
  isDisabled: PropTypes.bool,
  isRequesting: PropTypes.bool,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  align: PropTypes.oneOf(['right', 'left', 'center']),
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  name: PropTypes.string,
};

export default NkButtonGroup;
